<template>
    <v-container>
        <!-- div for help to place filter card -->
        <div class="mt-n16 white--text">.</div>

        <!-- filter -->
        <v-card class="mt-0 py-5" elevation="3">
            <v-row align="center" class="px-5">
                <v-col cols="auto">
                    <v-text-field
                        v-model="filter.email"
                        label="E-mailadres"
                        clearable
                        hide-details
                        dense
                        class="subtitle-2"
                    ></v-text-field>
                </v-col>
                <v-col cols="auto">
                    <v-text-field
                        v-model="filter.firstName"
                        label="Voornaam"
                        clearable
                        hide-details
                        dense
                        class="subtitle-2"
                    ></v-text-field>
                </v-col>
                <v-col cols="auto">
                    <v-text-field
                        v-model="filter.lastName"
                        label="Achternaam"
                        clearable
                        hide-details
                        dense
                        class="subtitle-2"
                    ></v-text-field>
                </v-col>
                <v-spacer />
                <v-col cols="auto">
                    <v-btn rounded color="primary" @click="addUser"
                        >Toevoegen</v-btn
                    >
                </v-col>
            </v-row>
        </v-card>

        <!-- data table card -->
        <v-card class="mt-3" elevation="3">
            <v-card-text class="pb-3">
                <v-data-table
                    :headers="headers"
                    :loading="$apollo.queries.tenantStaffs.loading"
                    :items="tenantStaffs.edges"
                    :expanded.sync="expanded"
                    item-key="node.id"
                    sort-by="node.user.email"
                    :sort-desc="false"
                    loading-text="Een ogenblik geduld aub..."
                    hide-default-footer
                    disable-pagination
                >
                    <!-- data table progress bar -->
                    <template v-slot:progress class="px-0 mx-0">
                        <v-progress-linear
                            absolute
                            height="2"
                            indeterminate
                        ></v-progress-linear>
                    </template>

                    <!-- no data availabel -->
                    <template slot="no-data">
                        <div>Geen gegevens beschikbaar</div>
                    </template>

                    <!-- email-->
                    <template v-slot:item.node.user.email="{ item }">
                        {{ item.node.user.email }}
                        <v-chip
                            small
                            v-if="item.node.user.id == me.id"
                            color="primary"
                            dark
                            >ik</v-chip
                        >
                    </template>

                    <!-- is administrator -->
                    <template v-slot:item.node.isAdmin="{ item }">
                        <v-icon v-if="item.node.isAdmin" color="success"
                            >check_circle</v-icon
                        >
                    </template>

                    <!-- enabled 2FA -->
                    <template v-slot:item.node.user.enabled2fa="{ item }">
                        <v-icon v-if="item.node.user.enabled2fa" color="success"
                            >check_circle</v-icon
                        >
                    </template>

                    <!-- formatted lastLogin date -->
                    <template v-slot:item.node.user.lastLogin="{ item }">
                        <span v-if="item.node.user.lastLogin">{{
                            item.node.user.lastLogin
                                | moment("DD-MM-YYYY HH:mm")
                        }}</span>
                    </template>

                    <!-- acions -->
                    <template v-slot:item.action="{ item }">
                        <v-btn
                            :disabled="!me.isTenantAdmin"
                            icon
                            outlined
                            small
                            color="primary"
                            class="mr-2"
                            @click="editUser(item.node)"
                        >
                            <v-icon small>edit</v-icon>
                        </v-btn>
                        <v-btn
                            :disabled="
                                !me.isTenantAdmin || item.node.user.id == me.id
                            "
                            icon
                            outlined
                            small
                            color="error"
                            @click="deletingUser(item.node)"
                        >
                            <v-icon small>delete</v-icon>
                        </v-btn>
                        <!-- <v-icon small @click="deletingPlant(item)">delete</v-icon> -->
                    </template>
                    <!-- expanded area -->
                    <!-- <template v-slot:expanded-item="{ headers, item }">
                        <td :colspan="headers.length" class="px-5 py-5">
                            <v-subheader>Groepen</v-subheader>
                            <v-row
                                v-for="group in item.node.allGroups.edges"
                                :key="group.node.id"
                            >
                                <v-col cols="6" sm="8" md="9">{{
                                    group.node.name
                                }}</v-col>
                            </v-row>
                        </td>
                    </template> -->
                </v-data-table>
            </v-card-text>

            <!-- infinit loading trigger -->
            <v-card-actions class="justify-center">
                <v-btn
                    v-if="hasMoreData"
                    v-intersect="onLoadMoreTriggerIntersect"
                    :disabled="!hasMoreData"
                    :loading="$apollo.queries.energyInvoices.loading"
                    text
                    class="mb-5"
                    @click="loadMore"
                >
                    Meer
                </v-btn>
            </v-card-actions>
        </v-card>

        <!-- Delete Tenant Staff Dialog -->
        <DeleteDialog
            :dialog.sync="deleteTenantStaffDialog"
            :item="deletedTenantStaff"
            v-on:confirmed="onDeleteConfirmed"
        >
            <template v-slot:title
                >Verwijderen -
                {{
                    deletedTenantStaff ? deletedTenantStaff.user.email : ""
                }}</template
            >
            <template v-slot:content
                >Weet u zeker dat u deze gebruiker wilt verwijderen?</template
            >
        </DeleteDialog>

        <GebruikerForm
            :dialog.sync="tenantStaffDialog"
            :object.sync="editedTenantStaff"
            v-on:done="refetchDate"
        ></GebruikerForm>
    </v-container>
</template>


<script>
import gql from "graphql-tag";
import helper from "@/utils/helper.js";
import DeleteDialog from "@/components/base/DeleteDialog.vue";
import GebruikerForm from "./forms/GebruikerForm.vue";

export default {
    title: "Gebruikers",
    components: { DeleteDialog, GebruikerForm },

    apollo: {
        tenantStaffs: {
            query: gql`
                query tenantStaffs(
                    $first: Int
                    $last: Int
                    $before: String
                    $after: String
                    $email: String
                    $firstName: String
                    $lastName: String
                    $orderBy: String
                ) {
                    tenantStaffs(
                        first: $first
                        last: $last
                        before: $before
                        after: $after
                        user_Email_Icontains: $email
                        user_FirstName_Icontains: $firstName
                        user_LastName_Icontains: $lastName
                        orderBy: $orderBy
                    ) {
                        pageInfo {
                            startCursor
                            endCursor
                            hasPreviousPage
                            hasNextPage
                        }
                        edges {
                            node {
                                id
                                user {
                                    id
                                    email
                                    firstName
                                    lastName
                                    lastLogin
                                    require2fa
                                    enabled2fa
                                }
                                isAdmin
                            }
                        }
                    }
                }
            `,
            variables() {
                return this.filter;
            },
            // Additional options here
            fetchPolicy: "cache-and-network",
            nextFetchPolicy: "cache-first", // this setting can avoid query again after fetchMore
            update: data => data.tenantStaffs,
            watchLoading(isLoading) {
                this.$emit("loading", isLoading);
            },
            debounce: 500,
            skip() {
                return this.me.isStaff;
            }
            // pollInterval: 60000 // ms
        }
    },

    data() {
        return {
            tenantStaffDialog: false,
            deleteTenantStaffDialog: false,
            editedTenantStaff: null,
            deletedTenantStaff: null,

            // graphql query filter
            filter: {
                first: 25,
                after: null,
                email: null,
                firstName: null,
                lastName: null,
                orderBy: "user__email"
            },
            expanded: [],
            tenantStaffs: {},

            // infinite loading trigger
            shouldLoadMore: false,

            headers: [
                {
                    text: "E-mailadres",
                    align: "left",
                    value: "node.user.email",
                    sortable: true
                },
                {
                    text: "Voornaam",
                    align: "left",
                    value: "node.user.firstName",
                    sortable: true
                },
                {
                    text: "Achternaam",
                    value: "node.user.lastName",
                    sortable: true
                },
                {
                    text: "Beheerder",
                    value: "node.isAdmin",
                    sortable: true
                },
                {
                    text: "2FA",
                    value: "node.user.enabled2fa",
                    sortable: true
                },
                {
                    text: "Laatst ingelogd",
                    value: "node.user.lastLogin",
                    sortable: true
                },
                {
                    text: "",
                    value: "action",
                    width: "120px",
                    align: "center",
                    sortable: false
                }
                // { text: "", value: "data-table-expand" }
            ]
        };
    },

    computed: {
        me() {
            return this.$store.state.user.me || {};
        },
        // infinite loading
        hasMoreData() {
            return this.tenantStaffs?.pageInfo?.hasNextPage;
        }
    },
    watch: {
        filter: {
            deep: true,

            handler() {
                this.refetchDate();
            }
        }
    },
    created() {
        this.hasPermission = helper.hasPermission;
    },
    mounted() {},
    methods: {
        // infinite loading trigger
        onLoadMoreTriggerIntersect(entries) {
            this.shouldLoadMore = entries[0].isIntersecting;

            if (
                this.shouldLoadMore &&
                this.tenantStaffs?.pageInfo?.hasNextPage
            ) {
                this.loadMore();
            }
        },
        refetchDate() {
            // use timeout to debouce
            if (this.timeout) clearTimeout(this.timeout);

            this.timeout = setTimeout(() => {
                this.$apollo.queries.tenantStaffs.refetch(this.filter);
            }, 800); // delay
        },
        loadMore() {
            if (this.tenantStaffs?.pageInfo?.hasNextPage) {
                this.$apollo.queries.tenantStaffs.fetchMore({
                    variables: {
                        after: this.tenantStaffs.pageInfo.endCursor
                    }
                });
            }
        },

        addUser() {
            this.editedTenantStaff = null;
            this.tenantStaffDialog = true;
        },
        editUser(user) {
            this.editedTenantStaff = JSON.parse(JSON.stringify(user));
            this.tenantStaffDialog = true;
        },
        deletingUser(item) {
            this.deletedTenantStaff = item;
            this.deleteTenantStaffDialog = true;
        },
        onDeleteConfirmed(item) {
            if (item) {
                const payload = {
                    id: item.id
                };

                this.$apollo
                    .mutate({
                        // Query
                        mutation: gql`
                            mutation deleteTenantStaff(
                                $input: DeleteTenantStaffInput!
                            ) {
                                deleteTenantStaff(input: $input) {
                                    tenantStaff {
                                        id
                                        isAdmin
                                        user {
                                            id
                                            email
                                            firstName
                                            lastName
                                            require2fa
                                            enabled2fa
                                            lastLogin
                                        }
                                    }
                                }
                            }
                        `,
                        // Parameters
                        variables: {
                            input: {
                                ...payload
                            }
                        }
                    })
                    .then(() => {
                        this.deleteTenantStaffDialog = false;
                        this.refetchDate();

                        // show snackbar
                        const payload = {
                            color: "success",
                            message: "De gebruiker is verwijderd!"
                        };
                        this.$store.dispatch("snackbar/showMessage", payload);
                    })
                    .catch(error => {
                        // Error
                        console.error(error);
                    })
                    .finally(() => {});
            }
        }
    }
};
</script>